// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import ListItem, { OrderedList, UnorderedList } from "@insite/mobius/Lists";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { SectionContainer, SectionTitle } from "@west/App/Widgets/DesignSystem/DesignSystem.helpers";
import typography from "@west/XDL/PreStyle/typography";
import React, { FC } from "react";
import { css } from "styled-components";

interface TypographyTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    smallGridItem?: GridItemProps;
    formWrapper?: InjectableCss;
}

const typogrphyTabStyles: TypographyTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            padding-bottom: 40px;
        `,
    },
    smallGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    formWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = typogrphyTabStyles;
const TypographyTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Hierarchy")}</SectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <Typography variant="h1">{translate(`H1 – [Font] ; [${typography["h1"].weight}] ; Font-Size: [${typography["h1"].size}] ; Line-Height: [${typography["h1"].lineHeight}] ; Margin-bottom: 20px`)}</Typography>
                <Typography variant="h2">{translate(`H2 – [Font] ; [${typography["h2"].weight}] ; Font-Size: [${typography["h2"].size}] ; Line-Height: [${typography["h2"].lineHeight}] ; Margin-bottom: 16px`)}</Typography>
                <Typography variant="h3">{translate(`H3 – [Font] ; [${typography["h3"].weight}] ; Font-Size: [${typography["h3"].size}] ; Line-Height: [${typography["h3"].lineHeight}] ; Margin-bottom: 12px`)}</Typography>
                <Typography variant="h4">{translate(`H4 – [Font] ; [${typography["h4"].weight}] ; Font-Size: [${typography["h4"].size}] ; Line-Height: [${typography["h4"].lineHeight}] ; Margin-bottom: 12px`)}</Typography>
                <Typography variant="h5">{translate(`H5 – [Font] ; [${typography["h5"].weight}] ; Font-Size: [${typography["h5"].size}] ; Line-Height: [${typography["h5"].lineHeight}] ; Margin-bottom: 12px`)}</Typography>
                <Typography variant="h6">{translate(`H6 – [Font] ; [${typography["h6"].weight}] ; Font-Size: [${typography["h6"].size}] ; Line-Height: [${typography["h6"].lineHeight}] ; Margin-bottom: 8px`)}</Typography>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <SectionTitle>Links</SectionTitle>
                <StyledWrapper {...styles.formWrapper}>
                    <Link href="https://www.google.com/">Google</Link>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.smallGridItem}>
                <SectionTitle>Numbered Lists</SectionTitle>
                <StyledWrapper {...styles.formWrapper}>
                    <OrderedList>
                        <ListItem>Numbered List Item </ListItem>
                        <ListItem>
                        Numbered List Item w/Sub List
                            <OrderedList>
                                <ListItem>Numbered sub-List Item</ListItem>
                                <ListItem>Numbered sub-List Item </ListItem>
                                <ListItem>Numbered sub-List Item </ListItem>
                            </OrderedList>
                        </ListItem>
                        <ListItem>Numbered List Item </ListItem>
                        <ListItem>Numbered List Item </ListItem>
                    </OrderedList>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.smallGridItem}>
                <SectionTitle>Bulleted Lists</SectionTitle>
                <StyledWrapper {...styles.formWrapper}>
                    <UnorderedList>
                        <ListItem>Unordered List Item</ListItem>
                        <ListItem>
                            Unordered List Item w/Sub list
                            <UnorderedList>
                                <ListItem>Unordered sub-List Item</ListItem>
                                <ListItem>Unordered sub-List Item</ListItem>
                                <ListItem>Unordered sub-List Item</ListItem>
                            </UnorderedList>
                        </ListItem>
                        <ListItem>Unordered List Item</ListItem>
                        <ListItem>Unordered List Item</ListItem>
                    </UnorderedList>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default TypographyTab;
